import './lib/browserCompat';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { GlossaryProvider } from './contexts/GlossaryContext';
import { storageGet } from './lib/browserCompat';
import './index.css';
import './styles/browser-compat.css';

const THEME_STORAGE_KEY = 'garuda_theme';

function getInitialTheme(): 'dark' | 'light' {
  const stored = storageGet(THEME_STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'dark';
}

const initialTheme = getInitialTheme();
document.documentElement.dataset.theme = initialTheme;
document.documentElement.style.colorScheme = initialTheme;

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Portal root element #root is missing');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <GlossaryProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </GlossaryProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
